var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_-_search_-_outlined",
    "data-name": "icon - search - outlined",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_105",
    "data-name": "Rectangle 105",
    width: 26,
    height: 26,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_16",
    "data-name": "Exclusion 16",
    d: "M26.3-8059.857h0l-4.943-4.943a6.912,6.912,0,0,1-4.441,1.62,6.917,6.917,0,0,1-6.91-6.908A6.918,6.918,0,0,1,16.91-8077a6.918,6.918,0,0,1,6.91,6.911,6.9,6.9,0,0,1-1.751,4.591L27-8060.564l-.707.707ZM16.91-8076A5.917,5.917,0,0,0,11-8070.089a5.916,5.916,0,0,0,5.909,5.909,5.916,5.916,0,0,0,5.909-5.909A5.917,5.917,0,0,0,16.91-8076Z",
    transform: "translate(-5.751 8081.168)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.e9c58c21a5f289459520b6895ce4e553.svg";
export { ForwardRef as ReactComponent };